var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-avatar',_vm._b({attrs:{"title":_vm.userTitle}},'v-avatar',_vm.$attrs,false),[(_vm.hasPicture)?_c('img',{attrs:{"src":_vm.avatarPictureBase64}}):_c('span',{staticClass:"text-h6 text-transform-upper",class:_vm.userInitials.length > 2 ? 'more-initials' : ''},[_vm._v(" "+_vm._s(_vm.userInitials)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }